import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const telegramIcon = `${process.env.PUBLIC_URL}/assets/Telegram.png`;
const whatsappIcon = `${process.env.PUBLIC_URL}/assets/Whatsapp.png`;
const maxIcon = `${process.env.PUBLIC_URL}/assets/Max.png`;
const closeAnimationMs = 220;

function Contacts({isOpen, onClose}) {
    const [shouldRender, setShouldRender] = useState(isOpen);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setIsClosing(false);
            return;
        }

        if (!shouldRender) {
            return;
        }

        setIsClosing(true);
        const timeoutId = setTimeout(() => {
            setShouldRender(false);
            setIsClosing(false);
        }, closeAnimationMs);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [isOpen, shouldRender]);

    if (!shouldRender) {
        return null;
    }

    return (
        <div
            className="contact-modal"
            id="contact-modal"
            aria-hidden="false"
            data-state={isClosing ? "closing" : "open"}
            onClick={onClose}
        >
            <div className="contact-panel" onClick={(event) => event.stopPropagation()}>
                <button
                    className="close-modal"
                    id="close-contact"
                    type="button"
                    aria-label="Закрыть окно контактов"
                    onClick={onClose}
                >
                    ×
                </button>

                <h4>Связаться с нами</h4>

                <div className="contact-priority">
                    <strong>Приоритетная связь — напрямую</strong>
                    <p>
                        Telegram, WhatsApp, MAX и звонок проверяются чаще. Заявку на сайте лучше оставлять, если
                        оперативность не критична.
                    </p>
                </div>

                <p className="contact-phone">
                    Тел.: <a href="tel:+79504030085">+7 (950) 403 00 85</a>
                    <br/>
                    Выберите мессенджер для связи:
                </p>

                <div className="contact-buttons">
                    <a
                        className="contact-btn"
                        href="https://t.me/SergeiBondarenko1"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={telegramIcon} alt="" aria-hidden="true"/>
                        <span>Telegram</span>
                    </a>
                    <a
                        className="contact-btn"
                        href="https://wa.me/79504030085"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={whatsappIcon} alt="" aria-hidden="true"/>
                        <span>WhatsApp</span>
                    </a>
                    <a
                        className="contact-btn"
                        href="https://max.ru/+79504030085"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={maxIcon} alt="" aria-hidden="true"/>
                        <span>MAX</span>
                    </a>
                </div>

                <div className="contact-request-card contact-service-card">
                    <strong>Не срочно?</strong>
                    <p>Оставьте заявку отдельной формой. Она попадёт в админку, но может проверяться реже.</p>
                    <Link className="contact-request-link contact-service-link" to="/request" onClick={onClose}>
                        Перейти к заявке
                    </Link>
                </div>

                <div className="contact-request-card contact-careers-card">
                    <strong>Хотите работать у нас?</strong>
                    <p>Будем рады видеть вас в команде. Заполните короткую заявку на работу, и мы свяжемся для обсуждения.</p>
                    <Link className="contact-request-link contact-careers-link" to="/staff/apply" onClick={onClose}>
                        Заполнить заявку на работу
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Contacts;
